import React, { useContext } from "react";
import PropTypes from "prop-types";
import { Api, callApi, DataContext, Loader } from "@cloudpremise/portal_core";
import MDButton from "@cloudpremise/portal_core/src/themes/mui/components/MDButton";
import MDModal from "@cloudpremise/portal_core/src/themes/mui/components/MDModal";
import MDBox from "@cloudpremise/portal_core/src/themes/mui/components/MDBox";
import MDTypography from "@cloudpremise/portal_core/src/themes/mui/components/MDTypography";
import MDInput from "@cloudpremise/portal_core/src/themes/mui/components/MDInput";
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

import { Account } from "../../types";
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';

const JsforceAccountModal = (props) => {
    const dataProvider = useContext(DataContext);
    let defaultState = {
        Id: "",
        AccountId: "",
        Name: "",
        AccountNumber: "",
        Website: "",
        Phone: "",
        modifiedFields: {},
        error: true,
        errorMessage: null,
        loading: false,
        deleteModal: false,
        hasModifiedFields: false
    };
    if(props.item !== null){
        defaultState = {
            ...defaultState,
            ...props.item,
            item: props.item
        };
    }
    const [state, setState] = React.useReducer((state: any, newState: Partial<any>) => ({
        ...state,
        ...newState
    }), defaultState);

    function handleChange(event, name){
        const value = event.target.value;
        setState({
            [name]: value,
            hasModifiedFields: true
        });
    }
    function onSuccess(){
        const data = {
            sObject: {
                Id: "",
                Name: "",
                AccountNumber: "",
                Phone: "",
                Website: "",
                attributes: {
                    type: "Account"
                }
            }
        };

        if(props.item !== null){
            // data.sObject = {
            //     ...props.item,
            // };
        }

        data.sObject = {
            ...data.sObject,
            Name: state.Name,
            AccountNumber: state.AccountNumber,
            Phone: state.Phone,
            Website: state.Website,
        };

        let method = 'POST';
        let params = {sobjecttypename: "Account"};
        if(state.hasOwnProperty("Id") && state.Id.length > 0){
            method = "PATCH";
            data.sObject = {
                ...data.sObject,
                Id: state.Id,
                attributes: state.attributes
            };
            params['Id'] = state.Id;
        }else{
            delete data['sObject']['Id'];
        }

        const record: Account = {
            sObjectTypeName: "Account",
            url: "/v1/sobject",
            method: method,
            params: params,
            headers: {},
            data: data
        }

        callApi(dataProvider, record).then((data: any) => {
            setState({
                sobject: data,
                accountModal: true,
                loading: false
            });
            let id = '';
            if(method === 'POST'){
                if(data.hasOwnProperty("Id")){
                    id = data.Id;
                }else{
                    id = data.id;
                }
            }else{
                id = state.Id;
            }
            props.onSuccess(id);
        }).catch(err => {
            console.log(err);
            let errorMessage = err.message;
            if(err.error){
                errorMessage = err.error;
            }
            setState({
                loading: false,
                error: true,
                errorMessage: errorMessage
            });
        });

        setState({
            loading: true,
            error: false
        });
    }
    function isFormValid(){
        const { Name } = state;
        if(Name.length > 0){
            return true;
        }
        return false;
    }

    return (
        <MDModal
            open={props.open}
            footer={
                (
                    state.loading ?
                        <Loader color="info" />
                    :
                        <>
                            {
                                state.error && state.errorMessage !== null ?
                                    <Stack p={1}>
                                        <Alert severity="error">{state.errorMessage}</Alert>
                                    </Stack>
                                :
                                <>
                                    <MDButton key="cancel" variant="gradient" color="light" onClick={() => props.onCancel(state.item)} >
                                        Cancel
                                    </MDButton>
                                    {
                                        state.Id.length > 0 ?
                                            <MDButton key="delete" variant="outlined" color="error" onClick={() => props.onObjectAction("delete")} >
                                                Delete
                                            </MDButton>
                                        :
                                        null
                                    }
                                    <MDButton key="save" variant="gradient" color="info" disabled={!isFormValid()} onClick={onSuccess}>
                                        Save & Close
                                    </MDButton>
                                </>
                            }
                        </>
                )
            }
            onClose={() => props.onCancel(state.item)}
            title={(props.item !== null ? "Update Account" : "New Account")}
            width="500px"
        >
            <div>
                <MDBox mb={2}>
                    <MDInput 
                        label="Account Name"
                        onChange={(event) => handleChange(event, "Name")}
                        value={state.Name}
                        sx={{width: "100%"}}
                        required={true}
                    />
                </MDBox>
                <MDBox mb={2}>
                    <MDInput 
                        label="Account Number"
                        onChange={(event) => handleChange(event, "AccountNumber")}
                        value={state.AccountNumber}
                        sx={{width: "100%"}}
                    />
                </MDBox>
                <MDBox mb={2}>
                    <MDInput 
                        label="Phone"
                        onChange={(event) => handleChange(event, "Phone")}
                        value={state.Phone}
                        sx={{width: "100%"}}
                    />
                </MDBox>
                <MDBox mb={2}>
                    <MDInput 
                        label="Website"
                        onChange={(event) => handleChange(event, "Website")}
                        value={state.Website}
                        sx={{width: "100%"}}
                    />
                </MDBox>
            </div>
        </MDModal>
    )
};

JsforceAccountModal.defaultProps = {
    item: null
}
JsforceAccountModal.propTypes = {
    classes: PropTypes.object,
    onCancel: PropTypes.func,
    onSuccess: PropTypes.func,
    onDelete: PropTypes.func,
    open: PropTypes.bool,
    item: PropTypes.object,
    verifiedEntity: PropTypes.object,
    basename: PropTypes.string,
    saving: PropTypes.bool,
    onObjectAction: PropTypes.func
};

export default JsforceAccountModal;